module.exports = __webpack_public_path__ + "static/media/bloc_jams_logo.af314a1e.png";